import enTranslations from '../utils/locales/en.json';

const useTranslationKeyExist = () => {
    const keyExists = key => enTranslations.hasOwnProperty(key);

    return keyExists;
};

export default useTranslationKeyExist;
